import { c as _c } from "react/compiler-runtime";
import { swapColumnOrder } from "@context-providers/table/column-preferences-utils";
import { useColumnPreferencesContext } from "@context-providers/table/column-preferences-provider";
import { TableEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback } from "react";

/**
 * Custom hook that provides a handler for column order changes.
 * Tracks the change and updates preferences in the backend.
 *
 * @param tableType - The type of table (for tracking purposes)
 * @param hasCheckboxColumn - Whether the table has a checkbox selection column (default: true)
 * @returns Handler function for column order changes
 */
export function useHandleColumnOrderChange(tableType, t0) {
  const $ = _c(7);
  const hasCheckboxColumn = t0 === undefined ? true : t0;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    columnPreferences,
    visibleOrderedColumns,
    updateColumnPreferences
  } = useColumnPreferencesContext();
  let t1;
  if ($[0] !== columnPreferences || $[1] !== hasCheckboxColumn || $[2] !== tableType || $[3] !== trackEvent || $[4] !== updateColumnPreferences || $[5] !== visibleOrderedColumns) {
    t1 = params => {
      if (!columnPreferences) {
        return;
      }
      const {
        oldIndex,
        targetIndex
      } = params;
      if (oldIndex !== targetIndex) {
        const updatedPreferences = swapColumnOrder(columnPreferences, visibleOrderedColumns, oldIndex, targetIndex, hasCheckboxColumn);
        const indexOffset = hasCheckboxColumn ? 1 : 0;
        const movedColumn = visibleOrderedColumns[oldIndex - indexOffset];
        trackEvent({
          name: TableEvents.changeColumnOrder,
          props: {
            type: tableType,
            column: movedColumn,
            order: targetIndex
          }
        });
        updateColumnPreferences(updatedPreferences);
      }
    };
    $[0] = columnPreferences;
    $[1] = hasCheckboxColumn;
    $[2] = tableType;
    $[3] = trackEvent;
    $[4] = updateColumnPreferences;
    $[5] = visibleOrderedColumns;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}